module["exports"] = ["روستا", "شهر", "دهکده", "بندر", "دژ", "بندرگاه", "ناحیه"];